<script lang="ts">
    import { Pagination as PaginationPrimitive } from "bits-ui";
    import ChevronLeftIcon from "@lucide/svelte/icons/chevron-left";
    import { buttonVariants } from "../../../components/ui/button/index.js";
    import { cn } from "../../../utils.js";
    import { m } from "../../../messages.svelte.js";

    let {
        ref = $bindable(null),
        class: className,
        children,
        ...restProps
    }: PaginationPrimitive.PrevButtonProps = $props();
</script>

{#snippet Fallback()}
    <ChevronLeftIcon class="size-4" />
    <span>{m["Previous"]()}</span>
{/snippet}

<PaginationPrimitive.PrevButton
    bind:ref
    aria-label="Go to previous page"
    class={cn(
        buttonVariants({
            size: "default",
            variant: "ghost",
            class: "gap-1 px-2.5 sm:pl-2.5",
        }),
        className,
    )}
    children={children || Fallback}
    {...restProps}
/>
